import React from 'react';
import DatePicker from 'react-datepicker';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { getActionType } from '../../../../Redux/reducer/logs';
import CustomSelect from '../../custom-components/select';

const ProviderFilters = (props) => {
  const { t } = useTranslation();
  const actionTypes = useSelector(state => getActionType(state));

  const { filters, handlerChange, updateDate } = props;
  return <div className="filters">
    <div className="row">
      <div className={`input col-lg-4`}>
        <label htmlFor="businessId">{t('logs.filters.form.businessId.label')}</label>
        <input type="text" id="businessId" name="businessId" value={filters.businessId} onChange={handlerChange} placeholder={t('logs.filters.form.businessId.placeholder')} />
        <span className="info">{t('logs.filters.form.optional')}</span>
      </div>
      <div className={`input col-lg-4`}>
        <label htmlFor="companyName">{t('logs.filters.form.clientnName.label')}</label>
        <input type="text" id="companyName" name="companyName" value={filters.companyName} onChange={handlerChange} placeholder={t('logs.filters.form.clientnName.placeholder')} />
        <span className="info">{t('logs.filters.form.optional')}</span>
      </div>
      <div className="input col-lg-4">
        <label htmlFor="createBy">{t('logs.filters.form.createBy.label')}</label>
        <input type="text" id="createBy" name="createBy" value={filters.createBy} onChange={handlerChange} placeholder={t('logs.filters.form.createBy.placeholder')} />
      </div>
    </div>
    <div className="row">
      <div className="input col-lg-4">
        <label className="fake-title" htmlFor="action">.</label>
        <CustomSelect id="transactionType" placeholder={t('logs.filters.form.transactionType.placeholder')} items={actionTypes} name="action" value={filters.action} valueAttr={`name`} handleChange={handlerChange} />
        <span className="info">{t('logs.filters.form.optional')}</span>
      </div>
      <div className="input col-lg-4">
        <label htmlFor="fromDate">{t('logs.filters.form.since.label')}</label>
        <DatePicker
          id="fromDate"
          name="fromDate"
          selected={filters.fromDate}
          onChange={(date) => updateDate(date, 'fromDate')}
          showMonthDropdown
          showYearDropdown
          showPopperArrow={false}
          dropdownMode="scroll"
          locale="es"
        />
        <span className="info">{t('logs.filters.form.optional')}</span>
      </div>
      <div className="input col-lg-4">
        <label htmlFor="toDate">{t('logs.filters.form.until.label')}</label>
        <DatePicker
          id="toDate"
          name="toDate"
          selected={filters.toDate}
          onChange={(date) => updateDate(date, 'toDate')}
          showMonthDropdown
          showYearDropdown
          showPopperArrow={false}
          dropdownMode="scroll"
          locale="es"
        />
        <span className="info">{t('logs.filters.form.optional')}</span>
      </div>
    </div>
  </div>
}

export default ProviderFilters;